module.exports = __webpack_public_path__ + "static/media/nb8.a49e7277.jpg";